module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/youtube-ae48fc06cd3b043bfd187156f6993899.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/youtube.svg
// module id = qW1Y
// module chunks = 24